import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { API_BASE_URL } from '../../config';
import './AdminLogin.css';

const AdminLogin = () => {
    const { t } = useTranslation(['admin', 'common']);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}admin_login.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                localStorage.setItem('adminId', data.admin.id);
                localStorage.setItem('adminUsername', data.admin.username);
                navigate('/admin/dashboard');
            } else {
                setError(data.message || t('admin:login.errors.invalid', 'Invalid credentials'));
            }
        } catch (err) {
            setError(t('admin:login.errors.connection', 'Failed to connect to the server'));
        } finally {

            setLoading(false);
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <h1>{t('admin:login.title', 'SkillAI Admin')}</h1>
                <p>{t('admin:login.subtitle', 'Enter your credentials to access the dashboard')}</p>


                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="username">{t('admin:login.username', 'Username')}</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder={t('admin:login.usernamePlaceholder', 'Enter admin username')}
                            required
                        />
                    </div>


                    <div className="form-group">
                        <label htmlFor="password">{t('admin:login.password', 'Password')}</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={t('admin:login.passwordPlaceholder', 'Enter password')}
                            required
                        />
                    </div>


                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? t('admin:login.loggingIn', 'Logging in...') : t('admin:login.button', 'Login to Dashboard')}
                    </button>

                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
